/**
 * Attribution for the Cleveland skyline photo used on the homepage teaser and
 * the Track Record deal card.
 *
 * The photo is CC BY 2.0, which REQUIRES a visible credit naming the author and
 * linking the licence. It is a component rather than inline markup so the two
 * usages cannot drift apart — a credit that is right on one page and wrong on
 * the other is worse than no component at all.
 */
export function PhotoCredit() {
  return (
    <p className="text-muted-foreground mt-2 text-right text-xs">
      Photo:{' '}
      <a
        href="https://www.flickr.com/photos/edrost88/54559384591/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground underline-offset-2 transition-colors hover:underline"
      >
        Erik Drost
      </a>{' '}
      /{' '}
      <a
        href="https://creativecommons.org/licenses/by/2.0/"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground underline-offset-2 transition-colors hover:underline"
      >
        CC BY 2.0
      </a>
    </p>
  )
}
